import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface DepositAccount {
    accountNumber: string;
    name: string;
    currency: string;
}

@Injectable({
    providedIn: 'root'
})
export class DepositAccountService {
    private apiUrl = '/api/deposit-accounts';

    constructor(private http: HttpClient) { }

    getDepositAccounts(accountType: number, parentAccount: number) {
        return this.http.get<DepositAccount[]>(
            `/api/deposit-accounts?accountType=${accountType}&parentAccount=${parentAccount}`
        );
    }
}
